export default __webpack_public_path__ + "static/media/Electricity_01.41e571ea.png";